import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import LegacyButton from '../LegacyButton';
import { Icons } from '@ohif/ui-next';

const StudyListFilter = ({
  filtersMeta,
  filterValues,
  onChange,
  clearFilters,
  isFiltering,
  numOfStudies,
  onUploadClick,
  getDataSourceConfigurationComponent,
  hasCheckedStudies,
  checkedStudiesCount,
  onActionButtonClick,
  hasAssignedStudies,
  onUnassignButtonClick,
}) => {
  const { t } = useTranslation('StudyList');

  // Always call getDataSourceConfigurationComponent to avoid hooks issues
  const dataSourceConfigComponent = getDataSourceConfigurationComponent
    ? getDataSourceConfigurationComponent()
    : null;

  return (
    <React.Fragment>
      <div style={{ display: hasCheckedStudies ? 'block' : 'none' }}>
        <div className="bg-black">
          <div className="container relative mx-auto flex flex-col pt-5">
            <div className="mb-5 flex flex-row justify-between">
              <div className="flex min-w-[1px] shrink flex-row items-center gap-6">
                {/* <Typography
                  variant="h6"
                  className="text-white"
                >
                  {t('StudyList')}
                </Typography> */}
                {hasCheckedStudies && (
                  <div className="mx-8 flex gap-3">
                    {onActionButtonClick && (
                      <button
                        className="bg-primary-active hover:bg-primary-active/90 rounded-full px-4 py-2 text-base font-semibold text-white"
                        onClick={onActionButtonClick}
                      >
                        {hasAssignedStudies ? t('Reassign Radiologist') : t('Assign Radiologist')} (
                        {checkedStudiesCount})
                      </button>
                    )}
                    {hasAssignedStudies && onUnassignButtonClick && (
                      <button
                        className="border-primary-active hover:bg-primary-active/20 rounded-full border-2 px-4 py-2 text-base font-semibold text-white"
                        onClick={onUnassignButtonClick}
                      >
                        {t('Unassign')} ({checkedStudiesCount})
                      </button>
                    )}
                  </div>
                )}
                {dataSourceConfigComponent}
                {onUploadClick && (
                  <div
                    className="text-primary-active flex cursor-pointer items-center gap-2 self-center text-lg font-semibold"
                    onClick={onUploadClick}
                  >
                    <Icons.Upload />
                    <span>{t('Upload')}</span>
                  </div>
                )}
              </div>
              <div className="flex h-[34px] flex-row items-center">
                {isFiltering && (
                  <LegacyButton
                    rounded="full"
                    variant="outlined"
                    color="primaryActive"
                    border="primaryActive"
                    className="mx-8"
                    startIcon={<Icons.Cancel />}
                    endIcon={undefined}
                    name="clear-filters"
                    onClick={clearFilters}
                  >
                    {t('ClearFilters')}
                  </LegacyButton>
                )}

                {/* <Typography
                  variant="h6"
                  className="mr-2"
                  data-cy={'num-studies'}
                >
                  {numOfStudies > 100 ? '>100' : numOfStudies}
                </Typography>
                <Typography
                  variant="h6"
                  className="text-primary-light"
                >
                  {`${t('Studies')} `}
                </Typography> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {numOfStudies > 100 ? (
        <div className="bg-primary-main py-1 text-center text-base">
          <p className="text-white">
            {t('Filter list to 100 studies or less to enable sorting')}
          </p>
        </div>
      ) : null}
    </React.Fragment>
  );
};

StudyListFilter.propTypes = {
  filtersMeta: PropTypes.arrayOf(
    PropTypes.shape({
      /** Identifier used to map a field to it's value in `filterValues` */
      name: PropTypes.string.isRequired,
      /** Friendly label for filter field */
      displayName: PropTypes.string.isRequired,
      /** One of the supported filter field input types */
      inputType: PropTypes.oneOf(['Text', 'MultiSelect', 'DateRange', 'None']).isRequired,
      isSortable: PropTypes.bool.isRequired,
      /** Size of filter field in a 12-grid system */
      gridCol: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]).isRequired,
      /** Options for a "MultiSelect" inputType */
      option: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string,
          label: PropTypes.string,
        })
      ),
    })
  ).isRequired,
  filterValues: PropTypes.object.isRequired,
  numOfStudies: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  isFiltering: PropTypes.bool.isRequired,
  onUploadClick: PropTypes.func,
  getDataSourceConfigurationComponent: PropTypes.func,
  /** Whether any checkboxes are checked */
  hasCheckedStudies: PropTypes.bool,
  /** Number of checked studies */
  checkedStudiesCount: PropTypes.number,
  /** Callback function when action button is clicked */
  onActionButtonClick: PropTypes.func,
  /** Whether any selected studies are already assigned */
  hasAssignedStudies: PropTypes.bool,
  /** Callback function when unassign button is clicked */
  onUnassignButtonClick: PropTypes.func,
};

export default StudyListFilter;
